import { Controller } from '@hotwired/stimulus'

// Sub-step 2/9 fiscalité / FATCA conditional fields:
// - reveals the NIF field (and toggles its `required`) when the tax residence
//   country is set and is not France
export default class extends Controller {
  static targets = ['taxResidence', 'nifField', 'nifInput']

  connect() {
    this.toggleNif()
  }

  toggleNif() {
    const country = this.taxResidenceTarget.value
    const requiresNif = country !== '' && country !== 'FR'

    this.nifFieldTarget.classList.toggle('d-none', !requiresNif)
    this.nifInputTarget.required = requiresNif
  }
}
